import React, { useState } from 'react'
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined'
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline'
import ArrowForward from '@mui/icons-material/ArrowForward'
import SearchHighlight from 'components/SearchHighlight'
import { parseStrapiImage } from 'utils'
import { Result, Preview, Details, Title, Meta, Snippet, DocumentIcon, OpenIndicator, PlayBadge } from './styled'

export default function SearchResultCard({ item, query, visual, label, onOpen }) {
  const [previewFailed, setPreviewFailed] = useState(false)
  return (
    <Result type="button" $visual={visual} onClick={onOpen} aria-label={item.title}>
      {item.kind === 'documents' ? <DocumentIcon><DescriptionOutlined aria-hidden="true" />{item.mime === 'application/pdf' ? <span>PDF</span> : null}</DocumentIcon> : (
        <Preview $visual={visual} $image={item.kind === 'images'}>
          {!previewFailed && item.image?.url ? <img src={parseStrapiImage(item.image.url)} alt="" loading="lazy" onError={() => setPreviewFailed(true)} /> : !previewFailed && item.kind === 'images' && item.document ? <img src={parseStrapiImage(item.document)} alt="" loading="lazy" onError={() => setPreviewFailed(true)} /> : item.kind === 'videos' ? <PlayCircleOutline aria-hidden="true" /> : <DescriptionOutlined aria-hidden="true" />}
          {(item.kind === 'videos' || item.video_id) && !previewFailed && item.image?.url ? <PlayBadge><PlayCircleOutline aria-hidden="true" /></PlayBadge> : null}
        </Preview>
      )}
      <Details>
        <Meta>{label}{item.mime === 'application/pdf' ? ' · PDF' : ''}</Meta>
        <Title><SearchHighlight text={item.title} query={query} /></Title>
        {!item.snippet ? null : <Snippet><SearchHighlight text={item.snippet} query={query} /></Snippet>}
      </Details>
      {visual ? null : <OpenIndicator><ArrowForward aria-hidden="true" /></OpenIndicator>}
    </Result>
  )
}
